/**
 * @description zabbix监控
 * @author 系统生成
 * @date 2018/9/20
 */

import Logic from '../logic-base'

const zabbixBiz = new Logic()

zabbixBiz.getNode = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.zabbixMonitor.getNode,
    data: data
  })
}

zabbixBiz.save = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.zabbixMonitor.save,
    data: data
  })
}

zabbixBiz.getStatus = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.zabbixMonitor.getStatus,
    data: data
  })
}

zabbixBiz.test = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.zabbixMonitor.test,
    data: data
  })
}

zabbixBiz.loginZabbix = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.zabbixMonitor.loginZabbix,
    data: data
  })
}

zabbixBiz.getTimeDelay = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.zabbixMonitor.getTimeDelay,
    data: data
  })
}

zabbixBiz.getRecentlyPro = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.zabbixMonitor.getRecentlyPro,
    data: data
  })
}

export default zabbixBiz
